import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';
import { Switch } from 'react-native-paper';

import { useFeature } from '@/features/feature-management/provider/useFeature';
import { useFeatureSettingStore } from '@/features/feature-management/store/featureSettingStore';
import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { usePopup } from '@/features/popup/provider/usePopup';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { OutlinedButton } from '@/shared/components/OutlinedButton';
import { StateView } from '@/shared/components/state-view/StateView';

export const FeatureSettingScreen: FC = () => {
  const { showAlert } = usePopup();
  const { t } = useTranslation(LocalizationNameSpace.FEATURE_MANAGEMENT, {
    keyPrefix: 'screens.settings'
  });

  const setFeature = useFeatureSettingStore((state) => state.setFeature);
  const setFeatures = useFeatureSettingStore((state) => state.setFeatures);

  const { features } = useFeature();

  return (
    <StateView>
      <ListSection>
        <OutlinedButton onPress={() => setFeatures([])} style={{ margin: 8 }}>
          {t('reset')}
        </OutlinedButton>
        {features.map((feature) => (
          <ListItem
            key={feature.featureIdentifier}
            title={feature.featureIdentifier}
            description={`local: ${feature.localEnabled}; remote: ${feature.remoteEnabled}; featureValues: ${JSON.stringify(feature.featureValues)}`}
            onPress={() => {
              if (
                !feature.featureValues ||
                Object.keys(feature.featureValues).length === 0
              )
                return;
              showAlert({
                labels: {
                  title: feature.featureIdentifier,
                  content: JSON.stringify(feature.featureValues, undefined, 2),
                  confirm: 'OK'
                }
              });
            }}
            arrowIcon={() => (
              <TouchableOpacity
                accessibilityRole="button"
                onPress={() => {}}
                style={{ flex: 1 }}
              >
                <Switch
                  value={feature.enabled}
                  onValueChange={(value) => {
                    setFeature(feature.featureIdentifier, value);
                  }}
                />
              </TouchableOpacity>
            )}
          />
        ))}
      </ListSection>
    </StateView>
  );
};
